import React, { FC, Suspense } from 'react';
import { graphql } from 'gatsby';

// eslint-disable-next-line import/no-extraneous-dependencies
import { Helmet as HelmetBase } from 'react-helmet';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Helmet = HelmetBase as any;

import {
  StyledSection,
  StyledContentBlock,
  ContentWrapper,
  ErrorBlock,
  AnimatedErrorBlock,
  AnimatedSVG,
  DescriptionWrapper,
  ErrorDescription,
  ErrorActions,
  RightArrow,
  ScanBlock,
  ScanTitle,
} from './styled';

import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import WidgetV2 from '../../components/WidgetV2';
import { handleRipple } from '../../helpers/ripple';

interface Props {
  locale: string;
}

const ErrorPage: FC<Props & { data?: Queries.ErrorPageQueryQuery | null }> = ({
  locale,
  data,
}) => {
  const { file } = data || {};
  const { image, animationImage, imageAlt, subText, buttonText, bannerTitle } =
    file?.childJson?.content || {};

  const handleBackToHome = () => {
    window.location.href = '/';
  };

  return (
    <>
      <Helmet>
        <html lang={locale} />
        <link
          rel="preconnect"
          href="https://fonts.bitcoin.com/Elza/Elza_Condensed_Black/crossmedia/Elza-CondensedBlack.woff"
          as="font"
          type="font/woff"
          crossOrigin="anonymous"
        />
        <link
          rel="preconnect"
          href="https://fonts.bitcoin.com/Satoshi_Variable/Fonts/WEB/fonts/Satoshi-Medium.woff"
          as="font"
          type="font/woff"
          crossOrigin="anonymous"
        />
        <style>
          {`
            @font-face {
              font-family: 'Elza Condensed';
              src: url('https://fonts.bitcoin.com/Elza/Elza_Condensed_Black/crossmedia/Elza-CondensedBlack.woff') format('woff');
              font-style: normal;
              font-display: swap;
            }
            @font-face {
              font-family: 'Satoshi Variable Medium';
              src: url('https://fonts.bitcoin.com/Satoshi_Variable/Fonts/WEB/fonts/Satoshi-Medium.woff') format('woff');
              font-weight: normal;
              font-style: normal;
              font-display: swap;
            }
          `}
        </style>
        <script
          src={
            process.env.MPC_WIDGET_URL ||
            'https://widget.bitcoin.com/widget.v0.7.14.iife.js'
          }
          type="text/javascript"
        />
      </Helmet>
      <Suspense fallback={<div style={{ height: '72px' }} />}>
        <Navbar
          navbar={file?.childJson?.navbar || null}
          locale={locale || ''}
        />
      </Suspense>
      <StyledSection>
        <StyledContentBlock>
          <ContentWrapper>
            <ErrorBlock>
              <AnimatedErrorBlock>
                {animationImage ? (
                  <AnimatedSVG
                    src={animationImage || undefined}
                    alt="404 Block Not Found Animation"
                  />
                ) : (
                  image && (
                    <AnimatedSVG
                      src={image || undefined}
                      alt={imageAlt || '404 Block Not Found'}
                    />
                  )
                )}
              </AnimatedErrorBlock>
              <DescriptionWrapper>
                <ErrorDescription>{subText}</ErrorDescription>
              </DescriptionWrapper>

              <ErrorActions
                onClick={() => handleBackToHome()}
                onMouseEnter={handleRipple}
              >
                {buttonText}
                <RightArrow className="right-arrow">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                    fill="none"
                  >
                    <path
                      d="M13.019 7.4389L7.62158 12.8373L6.74463 11.9604L10.646 8.05902H1.85986V6.81976H10.647L6.74463 2.9184L7.62158 2.04144L13.019 7.4389Z"
                      fill="#1C1C1C"
                    />
                  </svg>
                </RightArrow>
              </ErrorActions>
            </ErrorBlock>
            <ScanBlock>
              <ScanTitle>{bannerTitle}</ScanTitle>
              <WidgetV2 />
            </ScanBlock>
          </ContentWrapper>
        </StyledContentBlock>
      </StyledSection>
      <Suspense>
        <Footer footer={file?.childJson?.footer || null} />
      </Suspense>
    </>
  );
};

export const errorContentFragment = graphql`
  fragment ErrorContent on Json {
    content {
      title
      image
      animationImage
      imageAlt
      subText
      buttonText
      bannerTitle
    }
  }
`;

export default ErrorPage;
